import Api from "./Api";

export default class Search {
    static globalSearch({query, category}) {
        const req = '/search?format=json&search=' + query + (category ? `&category=${category}` : '');
        return Api.get(req)
            .then((json) => Object.keys(json).map((key) => ({...json[key], keyword: key})))
    }
}
